import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { getData } from '@util';
import '../style.scss';

const Option = Select.Option;

/**
 * 给 antd 的 select 包装一层请求
 * @param {import("antd/lib/select").SelectProps & {api: any}} props
 */
export default function AsyncSelect({
  api,
  label,
  require,
  placeholder,
  optionsMap,
  filter,
  ...props
}) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getData({ api }).then(res => {
      if (Array.isArray(res.data)) {
        if (filter) res.data = res.data.filter(filter);
        setOptions(optionsMap ? res.data.map(optionsMap) : res.data);
      } else if (Object.prototype.toString.call(res.data) === '[object Object]') {
        let tmpArr = [];
        Object.keys(res.data).forEach(key => {
          tmpArr.push({ code: key, name: res.data[key] });
        });
        if (filter) tmpArr = tmpArr.filter(filter);
        setOptions(optionsMap ? tmpArr.map(optionsMap) : tmpArr);
      } else {
        setOptions(optionsMap ? res.data.map(optionsMap) : res.data);
      }
    });
  }, [api]);
  return (
    <div className="commonInput">
      {label ? <label className={require ? 'show_required' : ''}>{label}：</label> : null}
      <div className="box" style={{ maxWidth: '70%' }}>
        <Select {...props} placeholder={placeholder || `请选择${label}`}>
          {options &&
            options.map(({ key, value, code, name }) => (
              <Option key={key || code} value={key || code}>
                {value || name}
              </Option>
            ))}
        </Select>
      </div>
    </div>
  );
}
